"use strict";

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
      r,
      ar = [],
      e;

  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) {
      ar.push(r.value);
    }
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }

  return ar;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MultiCardRadio = void 0;

var react_1 = __importStar(require("react"));

var react_theme_components_1 = require("@suezenv/react-theme-components");

require("@suezenv/react-theme-components/assets/css/main.css");

require("./MultiCardRadio.scss");

var clsx_1 = __importDefault(require("clsx"));

exports.MultiCardRadio = function (_a) {
  var _b = _a.border,
      border = _b === void 0 ? true : _b,
      cardsRadio = _a.cardsRadio,
      className = _a.className,
      onChangeRadio = _a.onChangeRadio,
      info = _a.info;

  var _c = __read(react_1.useState(), 2),
      currentIndex = _c[0],
      setCurrentIndex = _c[1];

  return react_1.default.createElement("div", {
    className: "row"
  }, cardsRadio === null || cardsRadio === void 0 ? void 0 : cardsRadio.map(function (cardRadio, index) {
    var onChangeCard = function onChangeCard(e) {
      setCurrentIndex(index);
      onChangeRadio(e, index, cardRadio.valueBtnSubmit || '', cardRadio.disabledBtnSubmit);
    };

    if (cardRadio.showCard !== undefined && !cardRadio.showCard) return null;
    if (cardRadio.textNotif !== undefined && cardRadio.textNotif !== '') return react_1.default.createElement(react_theme_components_1.SzAlert, {
      key: index,
      variant: "info",
      transparent: true,
      className: "h-25 col-lg-4 py-2 mx-3 mx-md-0"
    }, cardRadio.textNotif);
    return react_1.default.createElement("div", {
      key: index,
      className: clsx_1.default('col-lg-4 pr-3 mb-3 mb-md-5', className)
    }, react_1.default.createElement("div", {
      className: clsx_1.default('h-100 border-primary', {
        border: border
      })
    }, react_1.default.createElement("div", {
      className: clsx_1.default('py-3 mb-0 mb-md-3 col-12 choice-payment-mode', {
        'bg-brand-light': currentIndex === index
      })
    }, react_1.default.createElement("div", {
      className: "sz-checkbox checked custom-control custom-radio"
    }, react_1.default.createElement("input", {
      name: "radio",
      type: "radio",
      id: "cardRadio" + (index + 1),
      className: "custom-control-input",
      value: cardRadio.value,
      onChange: onChangeCard
    }), react_1.default.createElement("label", {
      htmlFor: "cardRadio" + (index + 1),
      className: "custom-control-label"
    }, cardRadio.title))), react_1.default.createElement("div", {
      className: clsx_1.default('d-md-block', {
        'd-none': cardRadio.noDisplayDesc
      })
    }, react_1.default.createElement(react_theme_components_1.SzTypographie, {
      weight: "regular",
      className: "col-12"
    }, cardRadio.titleText), react_1.default.createElement(react_theme_components_1.SzTypographie, {
      weight: "regular",
      className: "col-12"
    }, cardRadio.text))));
  }), info && react_1.default.createElement(react_theme_components_1.SzAlert, {
    variant: "info",
    transparent: true,
    className: "h-25 col-lg-4 py-2 mx-3 mx-md-0"
  }, info));
};

exports.default = exports.MultiCardRadio;